import classNames from 'classnames/bind';

import styles from './index.module.scss';
import { PRODUCTS } from './constants';
import Product from './Product';

const cx = classNames.bind(styles);

const S02 = () => {
  return (
    <section className={cx('container')}>
      <ul className={cx('wrapper')}>
        {PRODUCTS.map((product, index) => (
          <Product key={index} data={product} />
        ))}
      </ul>
    </section>
  );
};

export default S02;
